<!-- 制作印章 -->
<template>
    <page-container class="seal-create"
                    v-loading="loaddingCurr || loaddingOther"
                    element-loading-text="加载中...">
        <el-breadcrumb slot="header"
                       separator="/"
                       v-if="!hideFrame">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/seal' }"
                                replace>印章管理</el-breadcrumb-item>
            <el-breadcrumb-item><a>申请印章</a></el-breadcrumb-item>
        </el-breadcrumb>

        <p class="tip small-font">
            <a class="grey-text"
               @click="back()">&lt;返回上一页</a>
            <span class="fr">上海市电子印章公共服务平台客服电话：<span class="red-text">021-962600</span></span>
        </p>
        <div class="create-form-container"
             v-if="!showCropper">
            <h3 class="text-center">申请电子印章</h3>

            <el-form label-width="160px"
                     :model="form"
                     :rules="rules"
                     ref="create"
                     @submit.native.prevent="doSubmit"
                     class="create-form"
                     label-position="right">
                <el-form-item label="印章名称："
                              prop="seal_name">
                    <el-input placeholder="请输入印章名称"
                              class="form-item-width"
                              :maxlength="50"
                              v-model="form.seal_name"></el-input>
                </el-form-item>

                <el-form-item label="经办人名称："
                              prop="operator">
                    <el-input placeholder="请输入经办人名称"
                              class="form-item-width"
                              :maxlength="50"
                              v-model="form.operator"></el-input>
                </el-form-item>

                <el-form-item label="经办人手机号："
                              prop="operator_contact">
                    <el-input placeholder="请输入经办人手机号"
                              class="form-item-width"
                              :maxlength="50"
                              v-model="form.operator_contact"></el-input>
                </el-form-item>
                <el-form-item label="印章类型："
                              prop="mouldType">
                            <el-select size="small"
                                   class="query-item"
                                   v-model="form.mouldType">
                            <el-option v-for="[key, val] in Object.entries(wholeMould)"
                                       :key="key"
                                       :label="val"
                                       :value="key">
                            </el-option>
                        </el-select>
                </el-form-item>
                <el-form-item label="印章规格："
                                              prop="spec">
                    <el-cascader v-model="form.spec"
                                 class="spec-cascader"
                                 placeholder="请选择印章规格"
                                 :options="sealSpecOptions"
                                 :props="{ emitPath: false }"></el-cascader>
                </el-form-item>
                <el-form-item label="上传印章图片："
                              prop="pic_key">
                              <p v-if="!isAllowApply">未申请【{{ mouldName }}】印模，请先<span class="blue-text" @click="goMouldManage">前往申请</span></p>
                    <div class="horizonal-conatiner" v-else>
                        <div>
                            <el-upload class="upload-component form-item-width"
                                       drag
                                       action=""
                                       :disabled="Boolean(form.pic_key)"
                                       :show-file-list="false"
                                       accept="image/png, image/jpeg, image/gif, image/jpg"
                                       :before-upload="uploadImg">
                                <template v-if="form.pic_key">
                                    <img :src="imgUrl"
                                         class="middle-center"
                                         alt="">
                                    <!-- <div class="img-model transfrom-center">
                                        <div class="text-center">
                                            <i class="iconshangchuan1 upload-icon white-text"></i>
                                            <p>重新上传</p>
                                        </div>
                                    </div> -->
                                </template>
                                <template v-else>
                                    <i class="iconshangchuan1 grey-text upload-icon"></i>
                                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                </template>

                                <div class="el-upload__tip tip small-text text-center"
                                     slot="tip">支持图片格式：jpg、jpeg、png、gif</div>
                            </el-upload>
                        </div>
                        <a class="red-text extend-btn"
                           @click="showExample = true;">查看示例</a>
                    </div>
                </el-form-item>

                <el-form-item label=" ">
                    <el-button type="primary"
                               @click="doPreSubmit"
                               size="medium">提&nbsp;&nbsp;&nbsp;&nbsp;交</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 裁剪 -->
        <croper v-else
                :img-url="imgUrl"
                seal-type="normal"
                data-type="base64"
                :specs="sealOptions"
                :show-example.sync="showExample"
                @onSaveImage="doSaveImage"
                @onCancel="doCancel"></croper>

        <el-dialog title="印章剪裁示例"
                   :show-close="false"
                   :visible.sync="showExample"
                   width="790px">
            <div class="cropper-example-container">
                <div class="cropper-example-item">
                    <img class="item-img"
                         src="../../assets/images/seal/cropper-example001.png"
                         alt="">
                </div>
                <div class="cropper-example-item">
                    <img class="item-img"
                         src="../../assets/images/seal/cropper-example002.png"
                         alt="">
                </div>
                <div class="cropper-example-item">
                    <img class="item-img"
                         src="../../assets/images/seal/cropper-example003.png"
                         alt="">
                </div>
            </div>
            <div slot="footer"
                 class="text-center">
                <el-button type="primary"
                           @click="showExample = false">我知道了</el-button>
            </div>
        </el-dialog>

        <!-- ukey签署 -->
        <ukey-password-confirm :visible.sync="visibleUkey"
                               v-if="visibleUkey"
                               confirm-text="确定"
                               @onConfirm="doSubmit"></ukey-password-confirm>
    </page-container>
</template>

<script>
import PageContainer from '../../components/container.vue';
import Croper from '../../components/croper/index.vue';
import wholeMould from '../mould/mouldData';
import UkeyPasswordConfirm from '../sign/childs/ukey-password-confirm.vue';
import SealSpec from './SealSpec';

export default {
    name: 'SealCreate',
    components: { PageContainer, Croper, UkeyPasswordConfirm },
    data () {
        return {
            // 印章规格
            sealOptions: [
                {
                    height: 42,
                    key: 'CIRCULAR_42',
                    label: '圆形（直径42mm）',
                    type: 'CIRCULAR',
                    width: 42
                }
            ],
            sealSpecOptions: [new SealSpec('CIRCULAR'), new SealSpec('SQUARE'), new SealSpec('OVAL')],
            visibleUkey: false,
            timer: '',
            showCropper: false,
            showExample: false,
            base64Str: '', // 上传的图片
            expireTime: '',// 证书过期时间
            // 表单数据
            form: {
                mouldType: '',
                seal_name: "",
                spec: "CIRCULAR_42",
                pic_key: "",
                pic_type: "",
                cs_type: 1,
                not_after: "",
                cert: "",
                sign_data: "",
                operator: '',
                operator_contact: ''
            },
            ownedMould: [],
            rules: {
                seal_name: [{ required: true, message: '请输入印章名称', triggle: 'blur' }],
                operator: [{ required: true, message: '请输入经办人名称', triggle: 'blur' }],
                mouldType: [{ required: true, message: '请选择印章类型', triggle: 'blur' }],
                spec: [{ required: true, message: '请选择印章规格', triggle: 'blur' }],
                operator_contact: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error('经办人手机号不能为空'));
                        } else {
                            var reg = /^(\+86|86)?1[0-9]{10}$/;
                            if (!reg.test(value)) {
                                callback(new Error('手机号格式不正确'));
                            }
                        }
                        callback();
                    },
                    triggle: 'blur'
                }],
                pic_key: [{ required: true, message: '请上传印章图片', triggle: 'blur' }]
            },
            imgUrl: '',
            isAllowApply: true,
            sealList: [],
            wholeMould: wholeMould,
            loaddingOther: false,
            loaddingCurr: false
        };
    },
    inject: ['app'],
    computed: {
        quser () {
            return this.$store.getters.quser;
        },
        isPersonal () {
            return this.$store.getters.isPersonal;
        },
        areaType() {
            return this.$store.getters.system.areaType;
        },
        isUkeyLogin() {
            return this.$store.getters.isLP && !this.$store.getters.isEtl;
        },
        hideFrame () {
            return this.$route.query.hideFrame && this.$route.query.hideFrame !== 'false';
        },
        // 展示逻辑：默认公章，若公章已申请，则默认财务章，发票章、法人章依次
        applyMouldType() {
            const hasSealType = this.sealList.map( item => item?.mouldType ?? '');
            return Object.keys(this.wholeMould).filter( key => !hasSealType.find( mould => mould.mouldType === key) )[0];
        },
        mouldName() {
            return this.wholeMould[this.form.mouldType];
        },
        // 当前展示的印章类型所对应的印模状态
        currentMould() {
            return this.ownedMould.length && this.ownedMould.filter( item => item.mouldType === this.form.mouldType)[0];
        }
    },
    watch: {
        'currentMould': {
            async handler(nv) {
                this.isAllowApply = true;
                this.imgUrl = '';
                this.form.pic_key = '';
                if(this.form.mouldType === '00') {
                    return;
                }
                if(!nv) {
                    this.isAllowApply = false;
                } else {
                    this.form.pic_key = nv.picKey;
                    this.form.pic_type = 'png';
                    this.imgUrl = `${this.BASE_APP_PATH}/seal/image?fileKey=${nv.picKey}`;
                    let base64Str = await this.axios({
                        url: '/seal/base64',
                        method: 'GET',
                        params: { fileKey: nv.picKey }
                    });
                    base64Str = base64Str.data.result;
                    this.base64Str = base64Str;
                }
            },
            deep: true,
            immediate: true
        },
        'app.cert': {
            async  handler (nv) {
                if (nv) {
                    this.loaddingOther = true;
                    this.loaddingCurr = true;
                    await this.getSealData();
                    await this.getSealData(true);
                }
            },
            immediate: true
        },
        'applyMouldType': {
            handler(nv) {
                if(nv) {
                    this.form.mouldType = nv;
                }
            },
            immediate: true
        }
    },
    mounted() {
        if (this.areaType == 'MHQ' && this.isUkeyLogin) {
            this.wholeMould = {
                ...this.wholeMould,
                '06': '业务章',
            };
        }
        this.ownedmouldQuery();
    },
    // 判断公章是否申请
    methods: {
        goMouldManage() {
            this.$router.push({name: 'mould'});
        },
        // 获取已拥有的印章
        async getSealData (isCurrent = false) {

            let url = isCurrent ? '/seal/list/current' : '/seal/list/other';
            let requsetData = new FormData();
            if (isCurrent) {
                requsetData.append('sealData', this.app.sealData);
                requsetData.append('old', this.app.isOld);
                requsetData.append('picData', this.app.picData);
            }

            requsetData.append('cert', this.app.cert);
            try {
                let res = await this.axios({
                    url: url,
                    method: "POST",
                    data: requsetData
                });
                if (res.data.code === 0) {
                    if (isCurrent) {
                        this.sealList = [...this.sealList, ...res.data.currentSeals];
                    } else {
                        this.sealList = [...this.sealList, ...res.data.otherSeals];
                    }

                }
            } catch (error) {
                console.log(error);
            } finally {
                this.$nextTick(() => {
                    if (isCurrent) {
                        this.loaddingCurr = false;
                    } else {
                        this.loaddingOther = false;
                    }
                });
            }
        },
        // 获取已拥有的印模
        async ownedmouldQuery() {
            try {
                const resp = await this.axios({
                    url: '/seal/mould/query',
                    method: 'GET',
                });
                const { data } = resp;
                if(data.code === 0) {
                    this.ownedMould = data.result;
                }
            } catch (error) {
                console.log(error);
            }
        },

        async doPreSubmit () {
            try {
                await this.$refs.create.validate();
                this.visibleUkey = true;
            } catch (error) {
                console.log(error);
            }
        },

        // 更新印章申请的图片
        async getNewFileKey() {
            const { data: { fileKey } } = await this.axios({
                url: '/seal/getrealukeyimg',
                method: 'GET',
                params: { fileKey: this.form.pic_key }
            });
            const { data: {code, result} } = await this.axios({
                url: '/seal/base64',
                method: 'GET',
                params: { fileKey }
            });
            if(code) {
                return false;
            }else {
                return {
                    fileKey,
                    base64Str: result
                };
            }
        },

        /**
         * 提交表单
         */
        async doSubmit (pin) {
            try {
                this.loading = this.$loading({
                    text: '加载中...'
                });

                let resp, requsetData = new FormData();
                // 图片处理
                const result = await this.getNewFileKey();
                if(!result) {
                    return;
                }
                const { fileKey, base64Str} = result;
                this.form.pic_key = fileKey;
                await this.getSignData(base64Str, pin);

                if (!this.form.sign_data) {
                    return;
                }
                /**
                 * params {
                 *
                 * }
                 */
                /**
                 * 如果是LP LP_, user_id = this.quser.company.registerNo
                 *              user_name = this.quser.company.name
                 */
                let params = this.Utils.deepClone(this.form);
                params.cert = this.app.cert;
                if (this.isPersonal) {
                    params.user_id = this.quser.user.orgCode;
                    params.user_name = this.quser.user.name;
                } else {
                    params.user_id = this.quser.company.registerNo;
                    params.user_name = this.quser.company.name;
                }
                params.not_after = this.Utils.formatDate(new Date(params.not_after));
                params.user_type = this.isPersonal ? 1 : 2;
                // 处理成formdata 数据
                for (let key in params) {
                    requsetData.append(key, params[key]);
                }
                resp = await this.axios({
                    url: this.isPersonal ? '/seal/personal/apply' : '/seal/company/apply',
                    method: 'POST',
                    data: requsetData
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.$message.success('申请成功');
                    this.$router.back();
                } else {
                    this.$message.error(resp.message);
                }
            } catch (error) {
                console.warn(error);
            } finally {
                this.loading && this.loading.close();
            }
        },
        // 获取Ukey签署数据
        async getSignData (data, pin) {
            let resp;
            try {
                resp = await this.app.ukey.sign(
                    {
                        data,
                        pwd: pin
                    }
                );
                this.form.sign_data = resp.result;
            } catch (error) {
                if (error != 'cancel') {
                    if (error.code == '2181300449') {
                        this.$message.error('UKEY服务忙，请稍后再试');
                    } else {
                        this.$message.error(error.message);
                    }
                }
            }
        },

        //上传图片
        uploadImg (file) {
            let type = file.name.split('.')[1].toUpperCase();
            let types = ['JPG', 'PNG', 'JPEG', 'GIF'];
            let img = file.size ? file : file.target.files[0];
            const isLt5M = img.size / 1024 / 1024 < 5;

            if (!types.includes(type)) {
                this.$message.error('文件仅支持png，jpg，gif，jpeg格式！');
                return false;
            }


            if (!isLt5M) {
                this.$message.error('上传图片大小不能超过 5MB！');
                return false;
            }

            let reader = new FileReader();
            reader.onload = e => {
                this.imgUrl = e.target.result;
                this.showCropper = true;
            };
            reader.readAsDataURL(img);
            this.form.pic_type = type;
            return false;
        },

        // 取消
        doCancel () {
            this.showCropper = false;
        },

        // 保存裁剪的图片
        async doSaveImage () {
            this.loading = this.$loading({
                text: '印章图片生成中...'
            });
            try {
                let resp, imgBase64 = arguments[1] || '';
                let formData = new FormData();
                formData.append('imgBase64', imgBase64);
                this.imgUrl = imgBase64;

                resp = await this.axios({
                    url: '/seal/base64/upload',
                    method: 'POST',
                    data: formData
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.form.pic_key = resp.fileKey;
                    let base64Str = await this.axios({
                        url: '/seal/base64',
                        method: 'GET',
                        params: { fileKey: resp.fileKey }
                    });
                    this.showCropper = false;
                    base64Str = base64Str.data.result;
                    this.base64Str = base64Str;
                } else {
                    this.form.pic_key = '';
                    this.$message.error(resp.message);
                }
            } catch (error) {
                this.form.pic_key = '';
                console.log(error);
            } finally {
                this.loading && this.loading.close();
            }
        },
        back () {
            if (this.showCropper) {
                this.showCropper = false;
            } else {
                this.$router.back();
            }
        }
    },
    beforeDestroy () {
        clearInterval(this.timer);
    }
};
</script>

<style lang="less">
.seal-create {
    .upload-component .el-upload-dragger {
        background-color: @background-color-primary !important;
    }
    .el-upload-dragger {
        position: relative;
        img {
            margin: 0 auto;
        }
        .img-model {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            transition: all 0.3s;

            &:hover {
                opacity: 1;
                color: @white;
                background: @black-opacity-5;
            }
        }
    }
}
.cropper-example-container {
    overflow: hidden;
    .cropper-example-item {
        width: 230px;
        float: left;
        margin: 10px 10px;
        .item-img {
            display: block;
            width: 100%;
        }
    }
}
.croper-dialog {
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
        height: 100%;
    }
}
.el-cascader-menu {
    overflow: hidden;
}
.el-scrollbar__wrap {
    overflow-y: auto;
}
</style>
<style lang="less" scoped>
.seal-create {
    .form-item-width {
        width: 360px;
    }
    .small-font {
        padding: 20px 20px 10px;
        a {
            display: inline-block;
            cursor: pointer;
            &:hover {
                color: @red;
            }
        }
    }
    .create-form-container {
        width: 640px;
        margin: 0 auto;
        padding: 40px 0;
    }
    .create-form {
        margin-top: 30px;
    }
    .upload-icon {
        display: inline-block;
        font-size: 64px;
        margin-top: 35px;
    }
    .horizonal-conatiner {
        display: flex;
        .extend-btn {
            margin-left: 10px;
            height: 40px;
            cursor: pointer;
        }
    }
    .spec-cascader {
        width: 205px;
    }
}
</style>


